<template>
    <div>
        <VuePhoneNumberInput 
            v-model="phoneNumber" 
            no-validator-state
            @update="updateNumberPhone"
            :class="{'error':valid[component.name].valid === true}"
            :default-country-code="(input[component.name] !== null && typeof input[component.name].countryCode !== 'undefineted')?input[component.name].countryCode:''"
        />
        <div class="has-text-right">
            <p class="th is-size-7 mg-t-5"  :class="{'has-text-danger':valid[component.name].valid === true}">{{valid[component.name].valid === true?component.validation.errorMsg:component.display.description}}</p>
        </div>
    </div>
</template>
<script>
import VuePhoneNumberInput from 'vue-phone-number-input';
export default {
    props:['component','input','valid','checkValidatePhoneNumber'],
    components:{
        VuePhoneNumberInput,
    },
    data() {
        return {
            phoneNumber:'',
        }
    },
    created() {
        console.log("this.input[this.component.name] payload",this.input[this.component.name])
        this.phoneNumber = ( this.input[this.component.name] !== null &&  typeof this.input[this.component.name].value !== 'undefined')?this.input[this.component.name].value:''
    },
    methods: {
        updateNumberPhone(payload){
            payload['value']= (payload.phoneNumber !== null)?payload.phoneNumber.replace(/\s/g, ''):''
            this.input[this.component.name] = payload
            this.checkValidatePhoneNumber(this.valid[this.component.name].name,this.valid[this.component.name].validation.required)
        },
    },
}
</script>
<style scoped>

</style>
